module.exports = __webpack_public_path__ + "img/8.d1fea9b4.jpg";